import React, {useEffect, useState} from 'react';
import { withStyles } from "@mui/styles";
import {
  Button,
  FormControl,
  InputAdornment,
  MenuItem,
  OutlinedInput,
  Select,
  TableSortLabel,
} from '@mui/material';
import {SortIcon} from "../../../helpers/Icons";
import NullIcon from "../../../helpers/NullIcon";

const styles = {
  root:{
    flexDirection:'row',
    flexWrap:'wrap',
    backgroundColor: '#ffffff'
  },
  direction:{
    border:'1px solid #c4c4c4 !important',
    borderRadius:'0 4px 4px 0',
    // borderRadius:0,
    // marginLeft:'-1px',
    borderLeft: "0 !important",
    minWidth: 'unset',
    padding: 0,
  },
  nulls:{
    border:'1px solid #c4c4c4',
    borderRadius:'0 4px 4px 0',
    // marginLeft:'-1px',
    borderLeft: 0,
    minWidth: 'unset',
    padding: '0 4px',
  },
  select:{
    paddingLeft:'0.5rem',
    height: '34px',
    paddingTop: '4px',
    overflow:'hidden',
    borderRadius:'4px 0 0 4px',
    fontSize: '0.85rem',
    fontWeight: 400,
    '& > div:nth-child(2)':{
      paddingLeft: '0.5rem',
      overflow:'hidden',
      borderRadius:'4px 0 0 4px'
    }
  },
  start:{
    margin: 0,
    color:'rgba(0,0,0,0.87)',
  },
  text:{
    textTransform: 'uppercase',
    fontSize: '0.7225rem',
    fontWeight: 500,
    // color:'rgba(0,0,0,0.54)'
  },
  arrow:{
    fontWeight: 600,
    '& > svg > path':{
      color:'rgba(0,0,0,0.87)'
    }
  }
};

function SortControl(props) {
  const {columns, controller, handleOrderChange, classes} = props;

  const getSortOptions = (columns) => columns
    .filter(column => column.enabled)
    .map((column) => (Array.isArray(column.header) ? column.header : [column.header])
      .filter(opt => (!!opt.sort && !!opt.label))
      .map(opt => ({
        key: column.key + "_" + opt.sort,
        sort: opt.sort,
        label: opt.label,
        defAsc: opt.hasOwnProperty("asc") ? opt.asc : true,
      })))
    .flat();

  const [sortOptions, setSortOptions] = useState(getSortOptions(columns));
  const [sortMap, setSortMap] = useState(Object.fromEntries(getSortOptions(columns).map(opt => [opt.sort,opt])));

  useEffect(() => {
    const newOpts = getSortOptions(columns);
    setSortOptions(newOpts);
    setSortMap(Object.fromEntries(newOpts.map(opt => [opt.sort,opt])));
  }, [columns])

  const handleSortSelect = (sort) => {
    if(!sortMap[sort]){
      return;
    }
    const opt = sortMap[sort];
    handleOrderChange(sort, opt.defAsc);
  };

  const nulls = controller.orders[0].hasOwnProperty('n') && !controller.orders[0].n;
  return (
    <div>
      <FormControl
        className={classes.root}
        variant="outlined"
      >
        <Select
          id="dataSortSelect"
          className={classes.select}
          value={controller.orders[0].f}
          onChange={(e) => handleSortSelect(e.target.value)}
          input={
            <OutlinedInput
              margin='dense'
              // label="Sort:"
              startAdornment={
                <InputAdornment position="start" className={classes.start}>
                  <SortIcon style={{fontSize:'20px'}} />
                  <span className={classes.text}>Sort:</span>
                </InputAdornment>
              }
            />}
        >
          {sortOptions.map(option =>
            <MenuItem key={option.key} value={option.sort}>{option.label}</MenuItem>
          )}
        </Select>
        <Button
          id="dataSortDirection"
          variant="outlined"
          className={classes.direction}
          onClick={() => handleSortSelect(controller.orders[0].f)}
        >
          {nulls ?
            <NullIcon id="dataSortNulls" style={{margin: '0 -4px 0 4px'}} />
            : null
          }
          <TableSortLabel
            id={nulls ? 'dataSortAsc' : controller.orders[0].d ? 'dataSortAsc' : 'dataSortDesc'}
            className={`${classes.arrow} ${nulls ? 'dataSortAsc' : controller.orders[0].d ? 'dataSortAsc' : 'dataSortDesc'}`}
            active={true}
            direction={nulls ? 'asc' : controller.orders[0].d ? 'asc' : 'desc'}
          />
        </Button>
      </FormControl>
    </div>
  )
}

export default withStyles(styles)(SortControl);
